import React from 'react'

import { splitStyleProps } from '../../utils'
import { InputGroup } from '../InputGroup'
import { TextInput, TextInputProps } from '../TextInput'
import { InputRightElement } from '../InputElement'
import { Flex } from '../Flex'
import { Spinner } from '../Spinner'
import { Icon } from '../Icon'

export interface SearchInputProps extends TextInputProps {
  isSearching?: boolean
  iconColor?: string
}

export const SearchInput = ({
  isSearching,
  iconColor = 'pink.500',
  ...restProps
}: SearchInputProps) => {
  const [styleProps, rootProps] = splitStyleProps(restProps)

  return (
    <InputGroup w="100%" {...styleProps}>
      <TextInput type="search" pr="3rem" {...rootProps} />

      <InputRightElement>
        <Flex h="100%" w="3rem" justify="center" align="center" borderRadius="md" userSelect="none">
          {isSearching ? (
            <Spinner size="sm" color={iconColor} />
          ) : (
            <Icon name="search" color={iconColor} />
          )}
        </Flex>
      </InputRightElement>
    </InputGroup>
  )
}

export default SearchInput
